import { useQuery } from "@tanstack/react-query";
import type { ReligionOption } from "gsintegrations";
import { religionRepository } from "../repositories/religionRepository";

export const religionsQueryKey = () => ["religion", "list"];

export const useReligionsQuery = () => {
  return useQuery<ReligionOption[]>({
    queryKey: religionsQueryKey(),
    queryFn: () => religionRepository.getReligions(),
    // always enabled for this static list
    enabled: true,
    staleTime: 1000 * 60 * 5,
    gcTime: 60 * 60 * 1000,
    refetchOnMount: "always",
  });
};
